import React from "react";
import {
  Box,
  Card,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

const OfferPriceInfo = () => {
  const { t } = useTranslation();
  return (
    <Card sx={{ mt: 3, width: "400px" }}>
      <CardHeader
        disableTypography
        title={
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography color="textPrimary" variant="h6">
              Palmaia The House Of AiA
            </Typography>
          </Box>
        }
      />
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>{t("main.avg_price")}</TableCell>
            <TableCell>3380 PLN</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t("main.max_price")}</TableCell>
            <TableCell>12990 PLN</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t("main.min_price")}</TableCell>
            <TableCell>2110 PLN</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t("main.category")}</TableCell>
            <TableCell>5*</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t("main.country")}</TableCell>
            <TableCell>Turkey</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t("main.region")}</TableCell>
            <TableCell>Belek</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t("main.departure_from")}</TableCell>
            <TableCell>Warszawa / Katowice</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>{t("main.period")}</TableCell>
            <TableCell>21 {t(`main.days`)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};

export default OfferPriceInfo;
